import React from 'react';
import {QueryRenderer , graphql} from 'react-relay';
import environment from '../../RelayEnvironment';
import {MapLayers, Layer} from '../MapLayers/MapLayers';

class RouterComponent extends React.Component {
    constructor(props) {
        super(props);
        // console.log("routerprops",props.indicatorIdArray )
        this.state = {
            isDataInfoPopupVisible:false,
            isMapComponentHidden:true,
            centerAndzoom:{},
            savedIndicatorsIdarray:[]
          }
        }

 contains=(a, obj) =>{
  for (var i = 0; i < a.length; i++) {
      if (a[i].id === obj.id) {
          return true;
      }
  }
  return false;
}
indexof = (a, obj) =>{
  for (var i=0; i<a.length; i++){
    if(a[i].id === obj.id)
    return i;
  }

}

    // TODO: clean up the rest of this popup dialog handling code
    //   to lift state more gracefully
    SavePopupHandler = () => {
        console.log("SavePopupHandler is called")
        this.props.showSaveMapPopUp();
        this.props.onCloseDataInfoPopup();
    }

    ShareMapPopupHandler = () => {
        console.log("ShareMapPopupHandler is called")
        this.props.showShareMapPopUp();
        this.props.onCloseDataInfoPopup();
    }

    handleCloseMapPopup = () => {
        console.log("handleCloseMapPopup is called")
        this.props.closePopups();
    }

    closeShareMapPopup = () => {
        this.props.closePopups();
    }

    render() {
      return <div className="h-100">
        <MapLayers indicatordata = {null}
                            indicatorid = {null}
                            {...this.props}
                            handleSelectIndicator={this.props.handleSelectIndicator}
                            routeIndicatorId = {this.props.routeIndicatorId}
                            isDataInfoPopupVisible={this.props.isDataInfoPopupVisible}
                            dataInfoPopupIndicatorId={this.state.dataInfoPopupIndicatorId}
                            onCloseDataInfoPopup={this.props.onCloseDataInfoPopup}
                            handleMapLayerGeographyChanged = {this.props.handleMapLayerGeographyChanged}
                            centerAndzoom = {this.state.centerAndzoom}
                            isMapLayersVisible ={this.props.isMapLayersVisible}
                            globallyVisible = {this.props.globallyVisible}
                            isSaveMapPopUpVisible = {this.props.isSaveMapPopUpVisible}
                            showSaveMapPopUp = {this.props.showSaveMapPopUp}
                            isShareMapPopUpVisible = {this.props.isShareMapPopUpVisible}
                            showShareMapPopUp = {this.props.showShareMapPopUp}
                            SavePopupHandler = {this.SavePopupHandler}
                            ShareMapPopupHandler = {this.ShareMapPopupHandler}
                            closeShareMapPopup = {this.closeShareMapPopup}
                            mapLayersUpdate = {this.props.mapLayersUpdate}
                            >

        {this.props.indicatorIdArray.map((node,i) => {
            if(node == null) { return null; }
            const bivariate = node.length === 2;
            if(bivariate) {
                //console.log("RouterComponent bivariate map layers node:", node);
                return <QueryRenderer key={node}
                            environment={environment}
                            query={graphql`
                            query  RouterComponentBivariateQuery($input: MapLayerInput!)  {
                                indicatorMapLayer(layer:  $input)  {
                                    bivariateMapLegend {
                                      edges  {
                                        node  {
                                          quantile
                                          legendText
                                        }
                                      }
                                    }
                                    indicators  {
                                              edges  {
                                              node  {
                                                id
                                                indicatorName
                                                indicatorNamePlaintext
                                                year
                                                startYear
                                                endYear
                                                geographicUnit
                                                {
                                                  summaryLevelCode
                                                }
                                                dataDictionaryVariable  {
                                                  baseMultiplier
                                                  isLargerBetter
                                                  showDecimalPlaces
                                                  unitOfMeasure
                                                  searchableindicatorSet
                                                  {
                                                    edges
                                                    {
                                                      node
                                                      {
                                                        id
                                                        geographicUnit  {
                                                          name
                                                          summaryLevelCode
                                                        }
                                                        year
                                                        startYear
                                                        endYear
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                          `}
                        variables={{  "input":  {  "indicators": node  }  } }
                            render={({error, props}) => {
                            if (error) {
                                console.error(error);
                                return <div>Error!</div>;
                            }
                            if (!props){
                                return <div key={node[0]}/>
                            }
                            //console.log("id array------->",JSON.stringify(props))
                            //console.log("checkedIndicators", this.props.checkedIndicators);
                            if(props.indicatorMapLayer.indicators != null) {
                                let indicatorid = node[0] + "," + node[1];
                                return <Layer bivariate={true} key={indicatorid} indicatordata = {props}
                                indicatorid = {indicatorid}
                                 {...this.props}
                                handleSelectIndicator={this.props.handleSelectIndicator}
                                routeIndicatorId = {this.props.routeIndicatorId}
                                onDataInfoPopup={this.props.onDataInfoPopup}
                                handleMapLayerGeographyChanged = {this.props.handleMapLayerGeographyChanged}
                                onMapLayerPaletteChanged = {this.props.onMapLayerPaletteChanged}
                                position = {i}
                                opacity = {this.props.indicatorOpacityArray[i]}
                                palette = {this.props.indicatorPaletteArray[i]}
                                customPalette = {this.props.indicatorCustomPaletteArray[i]}
                                isIndicatorChecked = {this.props.checkedIndicators.includes(indicatorid) ? true : false}
                                handlecheckedIndicators = {this.props.handlecheckedIndicators}
                                isMapLayersVisible ={this.props.isMapLayersVisible}
                                globallyVisible = {this.props.globallyVisible}
                                />
                            } else {
                              return <div key={node}/>;
                            }
                }}/>
            }
            return <QueryRenderer key={node}
                        environment={environment}
                        query={graphql`
                        query  RouterComponentQuery($input:  MapLayerInput!)  {
                            indicatorMapLayer(layer:  $input)  {
                                indicators  {
                                          edges  {
                                          node  {
                                            id
                                            indicatorName
                                            indicatorNamePlaintext
                                            year
                                            startYear
                                            endYear
                                            geographicUnit
                                            {
                                              summaryLevelCode
                                            }
                                            dataDictionaryVariable  {
                                              baseMultiplier
                                              isLargerBetter
                                              showDecimalPlaces
                                              unitOfMeasure
                                              searchableindicatorSet
                                              {
                                                edges
                                                {
                                                  node
                                                  {
                                                    id
                                                    geographicUnit  {
                                                      name
                                                      summaryLevelCode
                                                    }
                                                    year
                                                    startYear
                                                    endYear
                                                  }
                                                }
                                              }
                                            }
                                            mapLegend  {
                                              edges  {
                                                node  {
                                                  quantile
                                                  legendText
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }


                      `}

                    variables={{  "input":  {  "indicators": [node]  }  } }
                        render={({error, props}) => {
                        if (error) {
                            console.error(error);
                            return <div>Error!</div>;
                        }
                        if (!props){
                            return <div key={node}/>
                        }
                        // console.log("id array------->",JSON.stringify(props))
                        if(props.indicatorMapLayer.indicators != null) {
                            let indicatorid = props.indicatorMapLayer.indicators.edges[0].node.id;
                            return <Layer key={indicatorid} indicatordata = {props}
                            indicatorid = {indicatorid}
                             {...this.props}
                            handleSelectIndicator={this.props.handleSelectIndicator}
                            routeIndicatorId = {this.props.routeIndicatorId}
                            onDataInfoPopup={this.props.onDataInfoPopup}
                            handleMapLayerGeographyChanged = {this.props.handleMapLayerGeographyChanged}
                            onMapLayerPaletteChanged = {this.props.onMapLayerPaletteChanged}
                            position = {i}
                            opacity = {this.props.indicatorOpacityArray[i]}
                            palette = {this.props.indicatorPaletteArray[i]}
                            customPalette = {this.props.indicatorCustomPaletteArray[i]}
                            isIndicatorChecked = {this.props.checkedIndicators.includes(indicatorid) ? true : false}
                            handlecheckedIndicators = {this.props.handlecheckedIndicators}
                            isMapLayersVisible ={this.props.isMapLayersVisible}
                            globallyVisible = {this.props.globallyVisible}
                            />
                        } else {
                          return <div key={node}/>;
                        }




            }}/>
        })}
        </MapLayers>
      </div>
    }




}


export default RouterComponent;



// WEBPACK FOOTER //
// ./src/components/RouterComponent/RouterComponent.js